import { Check } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface SidebarSection {
  id: string;
  title: string;
  items: SidebarItem[];
  content?: React.ReactNode;
}

export interface SidebarItem {
  id: string;
  label: string;
  selected?: boolean;
  onClick?: () => void;
}

interface SidebarProps {
  sections: SidebarSection[];
  className?: string;
}

export function Sidebar({ sections, className }: SidebarProps) {
  return (
    <aside className={cn('border-r border-ck-dark-border bg-ck-dark p-6', className)}>
      <div className="space-y-8">
        {sections.map(section => (
          <div key={section.id}>
            {section.title && (
              <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-ck-cyan">
                {section.title}
              </h3>
            )}
            {section.content ? (
              section.content
            ) : (
              <div className="space-y-2">
                {section.items.map(item => (
                  <button
                    key={item.id}
                    onClick={item.onClick}
                    className={cn(
                      'flex w-full items-center justify-between rounded-lg px-4 py-3 text-left text-sm font-medium transition-all',
                      item.selected
                        ? 'border border-ck-cyan bg-ck-cyan/10 text-ck-cyan'
                        : 'border border-transparent bg-ck-dark-card text-foreground hover:border-ck-dark-border hover:bg-ck-dark-card/70'
                    )}
                  >
                    <span>{item.label}</span>
                    {item.selected && <Check className="h-4 w-4" />}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </aside>
  );
}